module.exports = __webpack_public_path__ + "img/new_19.c32e85da.jpg";